import React from "react";
import ReactDOM from "react-dom/client";
import "@amzn/awsui-global-styles/polaris.css";
import App from "./App";

// Enable Polaris visual refresh for modern AWS UI design
document.body.classList.add("awsui-visual-refresh");
document.body.classList.add("awsui-polaris-light-mode");

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
